import EuroIcon from '@mui/icons-material/Euro';

import {
  FilterFieldContainer,
  FilterLabel,
  RangeInput,
  RangeInputContainer,
  RangeInputField,
  RangeInputIcon,
} from '../GeneratikTableFilterPanel.styles';
import { CurrencyRangeFieldProps } from '../GeneratikTableFilterPanel.types';
import { formatFilterNumber, parseFilterNumber } from './filterNumber';

const CurrencyRangeFilterField = ({
  field,
  value,
  onChange,
  t,
  disabled,
}: CurrencyRangeFieldProps) => (
  <FilterFieldContainer>
    <FilterLabel>{field.label}</FilterLabel>
    <RangeInputContainer data-testid={`filter-field-${field.id}`}>
      <RangeInput>
        <RangeInputIcon>
          <EuroIcon />
        </RangeInputIcon>
        <RangeInputField
          type="text"
          placeholder={t('Min')}
          value={formatFilterNumber(value.min || '')}
          onChange={(e) => onChange({ ...value, min: parseFilterNumber(e.target.value) })}
          disabled={disabled}
        />
      </RangeInput>
      <RangeInput>
        <RangeInputIcon>
          <EuroIcon />
        </RangeInputIcon>
        <RangeInputField
          type="text"
          placeholder={t('Max')}
          value={formatFilterNumber(value.max || '')}
          onChange={(e) => onChange({ ...value, max: parseFilterNumber(e.target.value) })}
          disabled={disabled}
        />
      </RangeInput>
    </RangeInputContainer>
  </FilterFieldContainer>
);

export default CurrencyRangeFilterField;
